import _ from 'lodash';
import { BMAuditBatchJson } from 'react-scale/components/audits/SpeedAudit/Gatekeeper/types';
import { AuditResult } from '@scale/shared/defaults';

// Binary weights produce audits that are too strict.
// TODO: tune these weights to better match predicted quality.
export const RULE_WEIGHTS: Record<AuditResult, number> = {
  [AuditResult.Perfect]: 1,
  [AuditResult.Good]: 1,
  [AuditResult.Ok]: 0.8,
  [AuditResult.Bad]: 0,
  [AuditResult.Terrible]: 0,
};

export const auditBatchQualityPercent = (auditBatch: BMAuditBatchJson) => {
  const results = auditBatch.attemptAudits;
  const totalScore = _.sumBy(results, r => (r.result ? RULE_WEIGHTS[r.result] : 0));
  const totalPossibleScore = _.sumBy(results, r => (r.result ? 1 : 0));
  const qualityScore = totalScore / totalPossibleScore;
  return `${parseFloat((qualityScore * 100).toFixed(2))}%`;
};
